import { z } from "zod";

const progressRecordSchema = z.object({
	eventType: z.string(),
	socketData: z.object({}).loose(),
	updatedAt: z.string(),
});

export const jobProgressResponseSchema = z.object({
	status: z.boolean(),
	meta: z.object({}).loose(),
	result: z.object({
		records: z.array(progressRecordSchema),
	}),
});

export { progressRecordSchema };

const jobLevelProgressStatusRecordSchema = z.object({
	id: z.string(),
	jobLevelId: z.string(),
	status: z.string(),
	message: z.string().nullable().optional(),
	createdAt: z.string(),
	jobLevel: z
		.object({
			buildingLevel: z
				.object({
					id: z.number(),
					level: z.number(),
				})
				.optional(),
		})
		.optional(),
});

export const jobLevelProgressStatusResponseSchema = z.object({
	status: z.boolean(),
	result: z.array(jobLevelProgressStatusRecordSchema),
});
